/**
 * Detail Level Submenu for TaskContextMenu
 * Extracted from TaskContextMenu.tsx
 */

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { type TaskDetailLevel, DETAIL_LEVELS } from '../../hooks/useBoardTaskDetailLevel';

const separatorStyle: React.CSSProperties = {
  height: 1,
  backgroundColor: '#e5e7eb',
  margin: '4px 0',
};

function SubmenuRadioItem({
  label,
  checked,
  onClick,
}: {
  label: string;
  checked: boolean;
  onClick: () => void;
}) {
  const [hovered, setHovered] = useState(false);
  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        width: '100%',
        padding: '6px 12px',
        fontSize: 13,
        color: '#1f2937',
        backgroundColor: hovered ? '#f3f4f6' : 'transparent',
        border: 'none',
        borderRadius: 6,
        cursor: 'pointer',
        textAlign: 'left',
      }}
    >
      <span style={{ width: 16, textAlign: 'center', fontSize: 12 }}>
        {checked ? '✓' : ''}
      </span>
      <span>{label}</span>
    </button>
  );
}

export function DetailLevelSubmenu({
  detailLevel,
  detailMode,
  parentX,
  onSetDetailLevel,
  onSetDetailAutoMode,
  onMouseEnter,
  onMouseLeave,
}: {
  detailLevel: TaskDetailLevel;
  detailMode: 'auto' | 'manual';
  parentX: number;
  onSetDetailLevel: (level: TaskDetailLevel) => void;
  onSetDetailAutoMode: () => void;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}) {
  const { t } = useTranslation();
  const openRight = parentX + 180 + 160 < window.innerWidth;

  return (
    <div
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{
        position: 'absolute',
        top: 0,
        [openRight ? 'left' : 'right']: '100%',
        marginLeft: openRight ? 2 : undefined,
        marginRight: openRight ? undefined : 2,
        zIndex: 10000,
        backgroundColor: '#fff',
        border: '1px solid #e5e7eb',
        borderRadius: 8,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        padding: 4,
        minWidth: 150,
      }}
    >
      <SubmenuRadioItem
        label={t('boardv3.detailLevels.auto')}
        checked={detailMode === 'auto'}
        onClick={onSetDetailAutoMode}
      />

      <div style={separatorStyle} />

      {DETAIL_LEVELS.map((level) => (
        <SubmenuRadioItem
          key={level}
          label={t(`boardv3.detailLevels.${level}` as any)}
          checked={detailMode === 'manual' && detailLevel === level}
          onClick={() => onSetDetailLevel(level)}
        />
      ))}
    </div>
  );
}
